import { Box, Grid } from '@material-ui/core';
import Modal from 'components/Modal';
import { AssuranceIcon } from 'images';
import React from 'react';

import {
  StyledBodyText,
  MediumSectionHeaderStyled,
  StyledGridButton,
} from 'components/AddNewContractSuccessModal/styles';
import messages from 'components/MenuItem/messages';
import { OrangeButton } from 'components/Button';
import { translate } from 'helpers/intl';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { getOpenModalSuccessSelector } from 'store/contract/selectors';
import { createStructuredSelector } from 'reselect';
import { openModalSucces, closeModalSucces } from 'store/contract/actions';
const AddNewContractSuccessModal = (props: any) => {
  return (
    <Modal
      open={props.isOpen}
      handleOpen={props.openModalSucces}
      handleClose={props.closeModalSucces}
      content={
        <>
          <Box paddingX={2} marginTop={3} marginBottom={3}>
            <Grid
              container
              alignItems="center"
              justify="center"
              direction="column"
              alignContent="center"
              spacing={3}
            >
              <Grid item xs>
                <img alt="" src={AssuranceIcon['checkAddContract']} />
              </Grid>
              <Grid item xs>
                <MediumSectionHeaderStyled weight="500" color="#04336B">
                  {translate({ ...messages.title_success_modal }, props)}
                </MediumSectionHeaderStyled>
              </Grid>
            </Grid>
            <StyledBodyText>
              {translate({ ...messages.description_success_modal }, props)}
            </StyledBodyText>
            <StyledGridButton>
              <OrangeButton
                variant="contained"
                onClick={
                  /* istanbul ignore next */ () => props.closeModalSucces()
                }
              >
                {translate({ ...messages.button_success_modal }, props)}
              </OrangeButton>
            </StyledGridButton>
          </Box>
        </>
      }
    ></Modal>
  );
};
const mapStateToProps = createStructuredSelector<
  any,
  {
    isOpen: boolean;
  }
>({
  isOpen: getOpenModalSuccessSelector,
});

const mapDispatchToProps = {
  closeModalSucces,
  openModalSucces,
};
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(AddNewContractSuccessModal));
